import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Youtube, Twitter, ArrowRight, MapPin, Mail, Phone } from "lucide-react";
import { Logo } from "./logo";

const services = [
  "Web Development", "Mobile App Development", "Backend & API Development",
  "Database Solutions", "Hosting & Deployment", "Maintenance & Support",
];
const tech = [".NET / .NET Core", "Angular", "React", "React Native", "SQL Server", "PostgreSQL", "Firebase"];
const legal = [
  ["Privacy Policy", "/privacy-policy"],
  ["Terms & Conditions", "/terms-conditions"],
];
const socials = [
  [Linkedin, "https://www.linkedin.com/company/sudeesha-solutions"],
  [Facebook, "https://www.facebook.com/profile.php?id=61559863916281"],
  [Instagram, "https://www.instagram.com/sudeesha23/"],
  [Youtube, "https://www.youtube.com/@Sudeesha23"],
  [Twitter, "https://twitter.com/sudeesha23"],
];

export const Footer = () => {
  return (
    <footer id="footer2" className="relative bg-[#05070f] overflow-hidden">
      <div className="absolute top-0 left-1/3 w-[500px] h-[300px] rounded-full bg-blue-700/10 blur-[120px]" />

      {/* CTA band */}
      <div className="relative max-w-6xl mx-auto px-4 pt-16">
        <div className="rounded-3xl glass-strong px-8 py-10 md:px-12 md:py-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 grid-overlay opacity-50" />
          <div className="relative">
            <h3 className="font-display text-white text-2xl md:text-4xl">
              Have a project in mind?
            </h3>
            <p className="mt-3 text-slate-400 max-w-xl mx-auto">
              Let's turn your idea into a scalable, production-ready product.
            </p>
            <a
              href="#contact"
              className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-extrabold text-white bg-gradient-to-br from-blue-600 to-violet-600 btn-glow hover:-translate-y-0.5 transition"
            >
              Start a Project <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Links */}
      <div className="relative max-w-6xl mx-auto px-4 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <Logo uid="footer" size={46} />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Building secure, scalable web &amp; mobile products from India.
            </p>
            <div className="space-y-2 text-sm text-slate-400">
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-blue-400" /> Chandigarh, India</div>
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-blue-400" /> sudeesha23@gmail.com</div>
              <div className="flex items-center gap-2"><Phone className="h-4 w-4 text-blue-400" /> +91 96468 32734</div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-extrabold mb-4">Services</h4>
            <div className="space-y-2.5">
              {services.map((t) => (
                <a key={t} href="#services" className="block w-fit text-slate-400 text-sm hover:text-white hover:translate-x-1 transition">{t}</a>
              ))}
            </div>
          </div>

          {/* Technologies */}
          <div>
            <h4 className="text-white font-extrabold mb-4">Technologies</h4>
            <div className="space-y-2.5">
              {tech.map((t) => (
                <a key={t} href="#services" className="block w-fit text-slate-400 text-sm hover:text-white hover:translate-x-1 transition">{t}</a>
              ))}
            </div>
          </div>
          {/* Legal & Compliance */}
          {/* Legal & Compliance */}
          <div>
            <h4 className="text-white font-extrabold mb-4">Legal & Compliance</h4>
            <div className="space-y-2.5">
              {legal.map(([t, path]) => (
                <a
                  key={t}
                  href={path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-fit text-slate-400 text-sm hover:text-white hover:translate-x-1 transition"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-extrabold mb-4">Follow Us</h4>
            <div className="flex flex-wrap gap-3">
              {socials.map(([Icon, href], i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="h-11 w-11 rounded-xl glass grid place-items-center text-slate-300 hover:text-white hover:bg-white/10 hover:-translate-y-0.5 transition"
                >
                  <Icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="hair-line mt-12" />
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <div>© {new Date().getFullYear()} Sudeeshaa Solutions. All rights reserved.</div>
          <div className="font-semibold">Crafted with precision in India 🇮🇳</div>
        </div>
      </div>
    </footer>
  );
};
